// extracted by mini-css-extract-plugin
export var chevronIcon = "_dx-2";
export var teamName = "_dx-1";
export var teamSwitcherButton = "_dx-0";